import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import employeesAction from 'store/app/entities/employees/action';
import authCompany from 'store/selectors/authCompany';
import isCompanyAdmin from 'store/selectors/isCompanyAdmin';

const mapStateToProps = state => ({
  authCompany: authCompany(state),
  isCompanyAdmin: isCompanyAdmin(state),
});

const mapDispatchToProps = dispatch => ({
  actions: {
    employees: bindActionCreators(employeesAction, dispatch),
  },
});

export default connect(mapStateToProps, mapDispatchToProps);
